<template>
  <section class="listing" style="padding: 20px 25px;">
    <div class="header">
      <div class="title">Validador</div>
    </div>
    <div v-if="shows.length === 0" class="no-shows">
      <i class="far fa-clipboard"></i>
      <div class="now-shows-text">Nenhum evento para hoje!</div>
    </div>
    <div v-if="show" class="dropdown">
      <div @click="openDrop = !openDrop" ref="selected" class="selected">
        <div class="calendar">
          <span>{{ getDay(show.date) }}</span>
          <span>{{ getMonthText(show.date) }}</span>
        </div>
        <div class="time-text">
          <span>{{ getHours(show.date) }}</span>
          <span>{{ getMinutes(show.date) }}</span>
        </div>
        <div class="data">
          <div class="main-data">{{ show.name }}</div>
          <div class="detail-data">{{ `${show.duration}min | ${show.type}` }}</div>
        </div>
        <div class="drop-action">
          <i class="fas fa-angle-down"></i>
        </div>
      </div>
      <div class="selection" :class="{ show : openDrop }" :style="`width: ${$refs.selected && $refs.selected.clientWidth || 0}px`">
        <div v-for="s in shows" :key="s.id" @click="selectShow(s)" class="selection-item" :class="{ active : s.id === show.id }">
          <div class="calendar">
            <span>{{ getDay(s.date) }}</span>
            <span>{{ getMonthText(s.date) }}</span>
          </div>
          <div class="time-text">
            <span>{{ getHours(s.date) }}</span>
            <span>{{ getMinutes(s.date) }}</span>
          </div>
          <div class="data">
            <div class="main-data">{{ s.name }}</div>
            <div class="detail-data">{{ `${s.duration}min | ${s.type}` }}</div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="shows.length > 0" class="validator">
      <!-- <video muted playsinline ref="camera" class="camera"></video> -->
      <canvas v-if="app" ref="canvas" class="camera"></canvas>
      <!-- Key -->
      <form @submit.prevent class="form">
        <input v-model="key" ref="key" v-mask="'###.###'" placeholder="___.___" maxlength="7" type="text" class="key-input" />
      </form>
      <transition name="show" mode="out-in">
        <i v-if="loading" class="fas fa-spinner loading-big"></i>
        <div v-if="!loading">
          <!-- Notify -->
          <div v-if="notify" class="nofify" :class="notify.type">
            <i class="fas" :class="notify.type === 'info' ? 'fa-check-circle' : notify.type === 'warn' ? 'fa-exclamation-circle' : 'fa-times-circle'"></i>
            <span>{{ notify.msg }}</span>
          </div>
          <!-- Ticket -->
          <div v-if="ticket" class="ticket-info">
            <div class="ticket-seat">
              <span :class="{ empty : !ticket.customerName }">
                <i v-if="ticket.seat" class="fas fa-chair" style="font-size: 0.8em"></i> {{ ticket.seat || '&nbsp;' }}
              </span>
              <span class="ticket-key">{{ ticket.key.substring(0, 3) }}.{{ ticket.key.substring(3) }}</span>
            </div>
            <div class="ticket-name" :class="{ empty : !ticket.customerName }">{{ ticket.customerName || ticket.name || '&nbsp;' }}</div>
            <div class="ticket-type" :class="{ empty : !ticket.ticketType }">{{ ticket.ticketType || '&nbsp;' }}</div>
          </div>
        </div>
      </transition>
      <div style="text-align:center;">
        <button v-if="app" @click="callCamera()" type="button" class="button-accept"><i class="fas fa-qrcode"></i></button>
      </div>
    </div>

    <div class="camera-content" v-show="camera"></div>
  </section>
</template>

<script>
// import jsQR from 'jsqr'
import logger from '../../logger'
import { getForValidator } from '../api/showDate'
import { validate } from '../api/ticket'

export default {
  name: 'validator',

  data () {
    return {
      app: process.env.CORDOVA_PLATFORM,
      loading: false,
      show: null,
      shows: [],
      openDrop: false,
      key: null,
      ticket: null,
      notify: null,
      video: null,
      stream: null,
      code: null,
      check: null,
      camera: false,
      checkCamera: null
    }
  },
  watch: {
    async key (value) {
      if (value && value.length === 7) {
        this.loading = true
        try {
          this.notify = null
          this.ticket = null
          this.ticket = await validate(this.show.id, value.replace('.', ''))
          this.notify = { type: 'info', msg: 'Ingresso validado com sucesso!' }
        } catch (error) {
          const data = error.response ? error.response.data : {}
          if (data.error === 'Ticket not found') {
            this.notify = { type: 'error', msg: 'Não encontrei esse ingresso!' }
            this.ticket = { key: value.replace('.', '') }
          } else if (data.error === 'Ticket already validated') {
            this.notify = { type: 'warn', msg: 'Este ingresso já foi validado!' }
            this.ticket = data.ticket
          } else if (data.error === 'Ticket unpaid') {
            this.notify = { type: 'error', msg: 'O boleto ainda não foi pago!' }
            this.ticket = data.ticket
          } else {
            logger.error(error, this)
          }
        }
        // if (!this.app) this.$refs.key.select()
        this.key = ''
        this.loading = false
      }
    }
  },
  created () {
    // Adapter for media devices
    /*
    if (navigator.mediaDevices === undefined) navigator.mediaDevices = {}
    if (navigator.webkitGetUserMedia) {
      navigator.mediaDevices.getUserMedia = function (constraints) {
        return new Promise(function (resolve, reject) {
          navigator.webkitGetUserMedia(constraints, resolve, reject)
        })
      }
    } */
  },
  async mounted () {
    try {
      // Shows
      this.shows = await getForValidator()
      this.show = this.shows[0]
      // if (this.app && this.shows.length > 0) this.startCamera()
    } catch (error) {
      logger.error(error, this)
    }
  },
  destroyed () {
    this.video = null
    // if (this.stream && this.stream.getTracks()) this.stream.getTracks().forEach((track) => track.stop())
  },
  methods: {
    selectShow (show) {
      this.show = show
      this.openDrop = false
    },
    callCamera () {
      if (this.app) {
        window.QRScanner.prepare(this.cameraOnDone)
      }
      // Make the webview transparent so the video preview is visible behind it.
      // window.QRScanner.show()
      // Be sure to make any opaque HTML elements transparent here to avoid
      // covering the video.
    },
    cameraOnDone (err, status) {
      if (err) {
        // here we can handle errors and clean up any loose ends.
      }
      if (status.authorized) {
        // W00t, you have camera access and the scanner is initialized.
        // window.QRscanner.show()
        document.body.style.display = 'none'
        document.getElementsByClassName('camera-content')[0].style.display = 'block'
        document.getElementsByClassName('camera-content')[0].style.opacity = 1
        this.camera = true
        window.QRScanner.show()
        setTimeout(() => {
          window.QRScanner.scan(this.cameraDisplayContents)
          this.checkCamera = setTimeout(() => {
            window.QRScanner.hide()
            window.QRScanner.destroy()
            document.body.style.display = 'block'
            document.getElementsByClassName('camera-content')[0].style.display = 'none'
            document.getElementsByClassName('camera-content')[0].style.opacity = 0
          }, 10000)
        }, 1000)
      } else if (status.denied) {
        // The video preview will remain black, and scanning is disabled. We can
        // try to ask the user to change their mind, but we'll have to send them
        // to their device settings with `QRScanner.openSettings()`.
      } else {
        // we didn't get permission, but we didn't get permanently denied. (On
        // Android, a denial isn't permanent unless the user checks the "Don't
        // ask again" box.) We can ask again at the next relevant opportunity.
      }
    },
    cameraDisplayContents (err, text) {
      if (err) {
        // an error occurred, or the scan was canceled (error code `6`)
      } else {
        // The scan completed, display the contents of the QR code:
        // alert(text)
        window.QRScanner.hide()
        window.QRScanner.destroy()
        document.body.style.display = 'block'
        document.getElementsByClassName('camera-content')[0].style.display = 'none'
        document.getElementsByClassName('camera-content')[0].style.opacity = 0
        clearTimeout(this.checkCamera)
        this.setCode(text)
      }
    },
    setCode (code) {
      this.camera = false
      this.key = code
      this.code = code
    },
    startCamera () {
      /*
      // setTimeout(async () => {
      this.$nextTick(async () => {
        try {
          this.video = document.createElement('video')
          const permission = await this.requestPermission()
          if (permission) {
            this.stream = await navigator.mediaDevices.getUserMedia({ audio: false, video: { facingMode: 'environment' } })
            this.video.srcObject = this.stream
            this.video.setAttribute('playsinline', true)
            this.video.play()
            requestAnimationFrame(this.tick)
          }
        } catch (error) {
          logger.error(error, this)
        }
      })
      // }, 2000)
      */
    },
    drawLine (begin, end, color) {
      /*
      this.$refs.canvas.getContext('2d').beginPath()
      this.$refs.canvas.getContext('2d').moveTo(begin.x, begin.y)
      this.$refs.canvas.getContext('2d').lineTo(end.x, end.y)
      this.$refs.canvas.getContext('2d').lineWidth = 8
      this.$refs.canvas.getContext('2d').strokeStyle = color
      this.$refs.canvas.getContext('2d').stroke()
      */
    },
    tick () {
      /*
      if (!this.video) return false
      if (this.video.readyState === this.video.HAVE_ENOUGH_DATA) {
        this.$refs.canvas.width = this.video.videoWidth
        this.$refs.canvas.height = this.video.videoHeight
        this.$refs.canvas.getContext('2d').drawImage(
          this.video,
          0,
          0,
          this.$refs.canvas.width,
          this.$refs.canvas.height
        )
        // if (this.check !== (new Date()).getSeconds()) {
        // this.check = (new Date()).getSeconds()
        const imageData = this.$refs.canvas.getContext('2d').getImageData(
          0,
          0,
          this.$refs.canvas.width,
          this.$refs.canvas.height
        )
        const code = jsQR(
          imageData.data,
          imageData.width,
          imageData.height,
          { inversionAttempts: 'dontInvert' }
        )
        if (code) {
          this.drawLine(code.location.topLeftCorner, code.location.topRightCorner, '#8900b3')
          this.drawLine(code.location.topRightCorner, code.location.bottomRightCorner, '#8900b3')
          this.drawLine(code.location.bottomRightCorner, code.location.bottomLeftCorner, '#8900b3')
          this.drawLine(code.location.bottomLeftCorner, code.location.topLeftCorner, '#8900b3')
          if (this.code !== code.data) {
            this.code = code.data
            this.key = code.data
          }
        }
        // }
      }
      requestAnimationFrame(this.tick)
      */
    },
    async requestPermission () {
      /*
      if (!process.env.CORDOVA_PLATFORM || process.env.CORDOVA_PLATFORM !== 'android') return Promise.resolve(true)
      return new Promise((resolve, reject) => {
        window.cordova.plugins.permissions.requestPermission(
          window.cordova.plugins.permissions.CAMERA,
          status => resolve((status.hasPermission)),
          error => reject(error)
        )
      })
      */
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";

@media screen and (min-width: 768px) {
.admin-router {
    margin-left: 200px !important;
  }
.listing {
    padding: 20px 25px;
  }
}

.listing {
  margin: 0;
  padding: 0;
  min-height: 1000px;
}
.camera-content {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: transparent;
  opacity: 1;
  display: none;
}

.camera {
  width: 200px;
  height: 200px;
  margin: 10px auto;
  border-radius: 5px;
  overflow: hidden;
}

.validator {
  text-align: center;

  form {
    max-width: 400px;
    margin: 0 auto;
    padding: 15px 0;
  }

  .key-input {
    font-size: 3em;
    text-align: center;
  }

  .nofify {
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 390px;
    margin: 0 auto;
    border-radius: 5px;
    color: #fff;
    padding: 15px 5px;
    text-align: center;

    &.info {
      background-image: linear-gradient(to bottom right, #027502, #00b800);
    }

    &.warn {
      background-image: linear-gradient(to bottom right, #aa8200, #d3d327);
    }

    &.error {
      background-image: linear-gradient(to bottom right, #aa0000, #cc0101);
    }

    i {
      font-size: 1.6em;
      margin-right: 15px;
    }

    span {
      font-size: 1.2em;
      font-weight: 300;
    }
  }

  .ticket-info {
    max-width: 400px;
    margin: 0 auto;
    border: 1px solid $secondary-color;
    border-radius: 5px;
    margin-top: 15px;

    .empty {
      background-color: #ddd;
      border-radius: 5px;
      padding: 2px 10px;
    }

    .ticket-seat {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 1.6em;
      font-weight: 500;
      color: $primary-color;
      border-bottom: 1px dashed $secondary-color;
      padding: 5px 10px;
    }

    .ticket-key {
      font-size: 0.9em;
      font-weight: 300;
      color: #777;
    }

    .ticket-name {
      font-size: 1.2em;
      font-weight: 400;
      color: #333;
      margin: 2px 10px;
      margin-top: 10px;
    }

    .ticket-type {
      display: inline-block;
      font-size: 0.9em;
      font-weight: 500;
      text-transform: uppercase;
      color: #444;
      background-color: #ddd;
      border-radius: 5px;
      padding: 2px 10px;
      margin: 5px 10px;
      margin-bottom: 10px;
    }
  }
}

.no-shows {
  background-color: #f7f8f9;
  color: #66758c;
  border-radius: 5px;
  padding: 20px 25px;
  max-width: 250px;
  margin: 50px auto;
  text-align: center;
  font-size: 1rem;

  i {
    font-size: 3rem;
    margin-bottom: 20px;
  }
}

.button-accept {
  position: fixed;
  bottom: 30px;
  color: #fff;
  border-radius: 20px;
  background-image: linear-gradient(to bottom right, $primary-color, $secondary-color);
  width: 90px;
  height: 60px;
  font-size: 36px;
  border-color: transparent;
  margin-left:-45px;
  &:focus {
    outline: 0;
  }
}

</style>
